<template>
  <div class="quantity-button">
    <el-button
      circle
      type="primary"
      icon="el-icon-plus"
      v-if="!active"
      @click="showQuantity">
    </el-button>
    <el-button
      style="margin-right: 10px;"
      v-if="active"
      type="danger"
      size="small"
      @click="hideQuantity">
      Annuler
    </el-button>
    <el-button
      style="margin-right: 10px;"
      v-if="active"
      type="success"
      size="small"
      @click="save">
      Enregistrer
    </el-button>
    <el-input-number v-if="active" size="small" v-model="quantity" :step="1"></el-input-number>
  </div>
</template>
<script>
export default {
  props: {
    defaultQuantity: { type: Number, default: 0 },
  },
  data() {
    return {
      active: false,
      quantity: this.defaultQuantity,
    };
  },
  methods: {
    showQuantity() {
      this.active = true;
    },
    hideQuantity() {
      this.active = false;
    },
    save() {
      this.hideQuantity();
      this.$emit('onValueSaved', this.quantity);
    },
  },
};
</script>
<style lang="stylus" scoped>
</style>
